import * as types from './action-types';
import fetch from '../lib/hmac-fetch.js';
import { trackFetchError } from '../lib/analytics.js';
import { fetchError, requestID } from './action-helpers.js';
import { doGetStaffSelf } from './staff-actions.js';
import { AANG_URL, HEADERS_JSON } from '../strings';

const getCheckin = (data) => {
  return {
    type: types.GET_CHECKIN,
    data,
  };
};

export const successCheckin = (data) => {
  return {
    type: types.SUCCESS_GET_CHECKIN,
    data,
  };
};

const errorCheckin = (data) => {
  return {
    type: types.ERROR_GET_CHECKIN,
    data,
  };
};

export function doGetCheckin(data, options = { bubble: false }) {
  return (dispatch, getState) => {
    const { staffs } = getState();
    data._request = data._request || requestID();
    dispatch(getCheckin(data));
    return fetch(`${AANG_URL}/checkins/${data.id}`, {
      headers: {
        ...HEADERS_JSON,
        'X-Request-ID': data._request,
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          throw fetchError({ response, data, message: 'Get checkin' });
        }
        return response.json();
      })
      .then((body) => {
        dispatch(successCheckin(body));
        if (staffs.user.id === body.staff_id && body.checkout_time) {
          dispatch(doGetStaffSelf(options));
        }
        if (options.bubble) return body;
      })
      .catch((error) => {
        dispatch(errorCheckin(error));
        trackFetchError(error);
        if (options.bubble) throw error;
      });
  };
}
